import { z } from 'zod'

// This module is imported by both the Cloud Functions bundle and the browser
// bundle. The browser build must never reach the Firestore admin SDK, so the
// require is lazy and guarded. Both globals are declared locally: the functions
// tsconfig has no DOM lib and the frontend tsconfig has no Node types, so
// neither side can see the other's global.
declare const require: (id: string) => any
declare const window: { document?: unknown } | undefined

const isBrowser = () =>
  typeof window !== 'undefined' && typeof window.document !== 'undefined'

// The returned schema also accepts the Firestore sentinel at runtime, but it is
// typed as the caller's schema on purpose: every consumer reads the resolved
// value, and widening the type to include the sentinel would push an unrelated
// narrowing burden onto every read site.
export function withFieldValue<T extends z.ZodTypeAny>(value: T): T {
  if (isBrowser()) {
    return value
  }

  const { FieldValue } = require('firebase-admin/firestore')

  return z.union([
    value,
    z.custom((data) => data instanceof FieldValue),
  ]) as unknown as T
}
